import React from "react";
import getClassName from "./utils/combineClassName";

type TagVariant = "default" | "success" | "warning" | "danger" | "neutral";

interface TagProps {
  children: React.ReactNode;
  variant?: TagVariant;
  className?: string;
}

const variantClasses: Record<TagVariant, string> = {
  default: "bg-electrum-100 text-electrum",
  success: "bg-green-100 text-green-700",
  warning: "bg-yellow-100 text-yellow-700",
  danger: "bg-red-100 text-red-700",
  neutral: "bg-gray-100 text-gray-600",
};

const Tag = ({ children, variant = "default", className }: TagProps) => {
  return (
    <span
      className={getClassName([
        "inline-block px-2 py-0.5 rounded-full text-xs font-medium",
        variantClasses[variant],
        className ?? "",
      ])}
    >
      {children}
    </span>
  );
};

export default Tag;
